import {
  Bank,
  ChartLineUp,
  DeviceMobile,
  Headset,
  Lightning,
  ShieldCheck,
} from "@phosphor-icons/react";
import { Reveal, ChapterTag } from "./Reveal";

const FEATURES = [
  {
    icon: ChartLineUp,
    title: "Competitive Rates",
    copy: "Market-tracked USDT to INR rates so you keep more of every exchange.",
    span: "lg:col-span-7",
    testId: "feature-rates",
  },
  {
    icon: Lightning,
    title: "Fast Processing",
    copy: "Exchanges and payouts move quickly — built for speed at every step.",
    span: "lg:col-span-5",
    testId: "feature-fast",
  },
  {
    icon: ShieldCheck,
    title: "Secure Transactions",
    copy: "Careful, security-first handling of every deposit and withdrawal.",
    span: "lg:col-span-4",
    testId: "feature-secure",
  },
  {
    icon: Bank,
    title: "Easy Withdrawals",
    copy: "Receive INR straight to your bank account with a simple withdrawal flow.",
    span: "lg:col-span-4",
    testId: "feature-withdrawals",
  },
  {
    icon: DeviceMobile,
    title: "Simple, User-Friendly App",
    copy: "A clean app experience designed to make exchanging effortless.",
    span: "lg:col-span-4",
    testId: "feature-simple",
  },
  {
    icon: Headset,
    title: "Dedicated Support",
    copy: "A real support team ready to help with deposits, exchanges and payouts.",
    span: "lg:col-span-12",
    testId: "feature-support",
  },
];

export default function WhyCoinAdda() {
  return (
    <section id="why-coin-adda" data-testid="why-section" className="relative border-t border-white/5 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <ChapterTag index="03" label="Why Coin Adda" />
          <h2 className="mt-6 max-w-2xl font-display text-3xl font-extrabold tracking-tighter text-slate-50 sm:text-5xl">
            Built for People Who <span className="text-[#00F5A0]">Value Every Rupee</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {FEATURES.map((feature, i) => (
            <Reveal key={feature.title} delay={Math.min(i * 0.08, 0.3)} className={feature.span}>
              <div
                data-testid={feature.testId}
                className="group h-full rounded-[1.75rem] border border-white/10 bg-[#0F172A]/60 p-8 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-[#00F5A0]/40 hover:shadow-[0_20px_60px_rgba(0,245,160,0.08)] sm:p-10"
              >
                <feature.icon size={36} weight="duotone" className="text-[#00F5A0]" />
                <h3 className="mt-5 font-display text-xl font-bold tracking-tight text-slate-50 sm:text-2xl">
                  {feature.title}
                </h3>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-400 sm:text-base">
                  {feature.copy}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
